import { computed } from "vue";
import { k as kebabCase_1 } from "../../vendor-b303cd6e.mjs";
const useCSSVariables = (prefix, cb) => {
  return computed(() => Object.entries(cb()).reduce((acc, [key, value]) => {
    acc[`--${prefix}-${kebabCase_1(key)}`] = value;
    return acc;
  }, {}));
};
export {
  useCSSVariables as u
};
//# sourceMappingURL=useCSSVariables-2f42e829.mjs.map
